import { render, staticRenderFns } from "./DocutaxSubmission.vue?vue&type=template&id=48a20f09&"
import script from "./DocutaxSubmission.vue?vue&type=script&lang=js&"
export * from "./DocutaxSubmission.vue?vue&type=script&lang=js&"
import style0 from "./DocutaxSubmission.vue?vue&type=style&index=0&id=48a20f09&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports